import { NavigationGuardWithThis } from "vue-router";
import { useIsFrozenStore } from "../stores/IsQuestionFrozenStore";

export const FrozenQuestionGaurd: NavigationGuardWithThis<
  undefined
> = async () => {
  const questionStatus = useIsFrozenStore();
  return questionStatus.isFrozen ? true : { path: "/questions" };
};
